import configurl from '@/config/user.env';
import { templateDownloadApi, importCustomerPersonResponsibleImport, importRespDetailImport, RespDetailtemplateDownloadApi } from '@mdm/api/customer/customerPersonResponsibleImport';
export const config = {
    action: configurl.apiUrl + 'api-lcrm/contractEnclosureInfo/upload',
    downloadApi: templateDownloadApi,
    importApi: importCustomerPersonResponsibleImport,
    downParams: {
        fileName: '责任制达成导入模板.xlsx',
        fileId: 'respAchievementImport.xlsx'
    },
    multiple: false,
    accept: '.xlsx,.xls',
    limtSizeKey: 'respAchievementImport',
    downBtn: true,
    showFileList: false,
    fileType: '只能上传Excel文件',
    manualUpload: true
};
export const detailConfig = {
    action: configurl.apiUrl + 'api-lcrm/contractEnclosureInfo/upload',
    downloadApi: RespDetailtemplateDownloadApi,
    importApi: importRespDetailImport,
    downParams: {
        fileName: '【收入】责任制数据初始化导入模板.xlsx',
        fileId: 'respAchievementImport.xlsx'
    },
    multiple: false,
    accept: '.xlsx,.xls',
    limtSizeKey: 'respDetailsImport',
    downBtn: true,
    showFileList: false,
    fileType: '只能上传Excel文件',
    manualUpload: true
};
